
function serialize(obj) {
    var arr = [];
    for (var i in obj) {
        if (obj.hasOwnProperty(i) && obj[i] && typeof obj[i] != 'function') {
            arr.push(i + '=' + obj[i]);
        }
    }
    return arr.join('&');
}


function getScript(url, callback) {
    var doc = document;
    var head = doc.head || doc.getElementsByTagName("head")[0];
    var script = doc.createElement("script");

    if ('onload' in script) {
        script.onload = onload;
    } else {
        script.onreadystatechange = function() {
            if (/loaded|complete/.test(script.readyState)) {
                onload();
            }
        }
    }

    function onload() {
        destory();
        typeof callback === 'function' && callback();
    }

    function destory() {
        script.onload = script.onreadystatechange = script.onerror = null;
        script = null;
    }

    script.async = true;
    script.src = url;
    head.appendChild(script);
}


function jsonp(url, opts, fn) {
    if ('function' == typeof opts) {
        fn = opts;
        opts = {};
    }
    if (!opts) opts = {};
    var count = (new Date()).getTime();
    var id = opts.name || ('__jp' + (count));
    var param = opts.param || 'callback';
    var enc = encodeURIComponent;

    function cleanup() {
        window[id] = null;
    }

    function cancel() {
        if (window[id]) {
            cleanup();
        }
    }

    window[id] = function(data) {
        cleanup();
        if (fn) fn(data);
    };

    url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
    url = url.replace('?&', '?');

    getScript(url);
}

function getQueryString(key) {
    var search = location.search.slice(1),
        array = search.split('&');
    for (var i = 0, len = array.length; i < len; i++) {
        var kv = array[i].split('=');
        if (kv[0] === key) {
            return kv[1];
        }
    }
};

function jumpByIframe(URL) {
    var ifr = document.createElement('iframe');
    ifr.src = URL;
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    setTimeout(function() {
        document.body.removeChild(ifr);
    }, 2000);
}

//防止通过iframe的方式嵌入到第三方网站里，location.href打不开app
function jump(URL) {
    if (window == window.top) {
        location.href = URL;
    } else {
        window.top.location.href = URL;
    }
}

function jumpInHuya(url) {
    if(window.HuyaKiwi && window.HuyaKiwi.HUYASdk) {
        window.HuyaKiwi.HUYASdk.openUrl({ url })
    } else {
        getScript('https://hd2.huya.com/fedbasic/huya-kiwi/huya-kiwi.bundle.1.3.2.umd.js', () => {
            window.HuyaKiwi.HUYASdk.openUrl({ url })
        })
    }
}

function Loading() {
    var _LoadingHtml = `<div id="loadingDiv">
        <div id="over" style="position: fixed;top: 0;left: 0; width: 100%;height: 100%; background-color: #000; opacity:0.6;z-index: 9999;"></div>
        <div id="layout" style="position: absolute;top: 40%; left: 40%;width: 20%; height: 20%; z-index: 10001;text-align:center;">
            <img src="https://a.msstatic.com/huya/main/assets/img/loading.gif" />
        </div>
    </div>`;

    return {
        show: function() {
            var oDiv = document.getElementById("loadingDiv")
            if(oDiv) {
                oDiv.style.display="block";
            } else {
                var body = document.body;
                oDiv =  document.createElement('div');
                oDiv.innerHTML = _LoadingHtml;
                body.appendChild(oDiv); 
            }
        },
        hide: function() {
            var oDiv = document.getElementById("loadingDiv")
            if (oDiv) {
               oDiv.style.display="none"; 
            }
        }
    }
}

export {
    serialize,
    getScript,
    getQueryString,
    jsonp,
    jumpByIframe,
    Loading,
    jumpInHuya,
    jump
};


// WEBPACK FOOTER //
// ./src/utils/utils.js